/** Схемы разделов дневника (как GetParts в UESprClientHistory). */

export const DIARY_PARTS_CONSULT = [
  { idSpr: 809, name: "Общие сведения (Шифр по МКБ-10)" },
  { idSpr: 4102, name: "Анамнез заболевания" },
  { idSpr: 4103, name: "Анамнез жизни" },
  { idSpr: 805, name: "Протокол консультации" },
  { idSpr: 806, name: "Заключение консультации" }
];

export const DIARY_PARTS_DISCHARGE = [
  {
    idSpr: 11019,
    name: "Краткий анамнез, диагностические исследования, течение болезни, проведенное лечение, состояние при направлении, при выписке"
  },
  { idSpr: 11020, name: "Лечебные и трудовые рекомендации" }
];

/** id1 === 2 → выписка, иначе консультация. */
export function getDiaryPartSchema(id1) {
  return Number(id1) === 2 ? DIARY_PARTS_DISCHARGE : DIARY_PARTS_CONSULT;
}

/**
 * Собрать секции для WYSIWYG-редактора ({ idPart, name, value }).
 */
export function buildDiaryEditorSections(id1, parts) {
  const schema = getDiaryPartSchema(id1);
  const bySpr = new Map();
  (parts || []).forEach((p) => {
    const idSpr = p.idSpr ?? p.idPart;
    if (idSpr != null) bySpr.set(Number(idSpr), p.value ?? p.fValue ?? "");
  });

  return schema.map((s) => ({
    idPart: s.idSpr,
    name: s.name,
    value: bySpr.has(s.idSpr) ? bySpr.get(s.idSpr) : ""
  }));
}

export function editorSectionsToDiaryParts(sections) {
  return (sections || []).map((s) => ({
    idSpr: s.idPart,
    name: s.name,
    value: s.value ?? ""
  }));
}
